import React, { useEffect, useRef, useState } from "react";
import { View, Text, StyleSheet } from "react-native";
import { FlatList } from "react-native-gesture-handler";

import useDebounce from "@hooks/useDebounce";
import { scale } from "@utils/scale";

const ITEM_HEIGHT = scale(40);

const Item = ({ item, index, currentIndex }) => {
  return (
    <View
      style={{
        height: ITEM_HEIGHT,
        justifyContent: "center",
        opacity: index === currentIndex ? 1 : 0.3,
      }}
    >
      <Text style={styles.listText}>{item?.key}</Text>
    </View>
  );
};

const WheelPicker = ({ data, onChange, value }) => {
  const [currentIndex, setIndex] = useState(0);
  const newVal = useDebounce(currentIndex, 300);

  useEffect(() => {
    onChange(data[newVal].value);
  }, [data, newVal, onChange]);

  const scrollRef = useRef();

  useEffect(() => {
    const idx = data.findIndex((item) => item.value === Number(value));
    scrollRef.current.scrollToOffset({
      offset: ITEM_HEIGHT * idx,
      animated: true,
    });
  }, [value]);

  return (
    <View style={styles.container}>
      <View style={[{ bottom: ITEM_HEIGHT + 5 }, styles.separator]} />
      <FlatList
        data={data}
        ref={scrollRef}
        keyExtractor={(item, index) => `${index}_${item}`}
        renderItem={({ item, index }) => (
          <Item item={item} index={index} currentIndex={currentIndex} />
        )}
        onScroll={(event) => {
          const index =
            Math.round(event.nativeEvent.contentOffset.y) / ITEM_HEIGHT;
          const roundIndex = Math.round(index);
          setIndex(roundIndex);
        }}
        bounces={false}
        decelerationRate="fast"
        scrollEventThrottle={16}
        snapToInterval={ITEM_HEIGHT}
        currentIndex={currentIndex}
        contentContainerStyle={{
          paddingTop: ITEM_HEIGHT,
          alignItems: "center",
          justifyContent: "center",
        }}
        showsVerticalScrollIndicator={false}
        initialNumToRender={data?.length}
        itemVisiblePercentThreshold={70}
        onScrollToIndexFailed={(error) => {
          scrollRef.scrollToOffset({
            offset: error.averageItemLength * error.index,
            animated: true,
          });
          setTimeout(() => {
            if (data.length !== 0 && scrollRef !== null) {
              scrollRef.scrollToIndex({
                index: error.index,
                animated: true,
              });
            }
          }, 100);
        }}
      />
      <View style={[{ top: ITEM_HEIGHT - 10 }, styles.separator]} />
    </View>
  );
};

export default WheelPicker;

const styles = StyleSheet.create({
  container: {
    height: ITEM_HEIGHT * 3,
    justifyContent: "center",
    alignItems: "center",
    position: "relative",
    flexDirection: "row",
    width: 60,
  },
  separator: {
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    width: 130,
    position: "absolute",
  },
  listText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 16,
    textAlign: "center",
    height: ITEM_HEIGHT,
  },
});
